import React from 'react';
import { Helmet } from "react-helmet";

//CORE COMPOENTNS
import { ThemeProvider, styled } from '../../../components-core/packages/components-core/dist/theme-provider';
import scroll from '../lead-section/LeadSection'
//LAYOUT
import {
    Container,
    ContainerGutter,
    ContainerWrap,
    ContainerPadding,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';

//STYLE
import { Text, TextAppearance, TextAlignment, TextColor } from '../../../components-core/packages/components-core/dist/text';
import { Button, ButtonAppearance } from '../../../components-core/packages/components-core/dist/button'
import LayoutTwo from '../../components/layouttwo'
import { Link } from '../../../components-core/packages/components-core/dist/link/index';

import { Image } from '../../../components-core/packages/components-core/dist/image/index';

import { Layout } from '../../../components-core/packages/components-core/dist/layout/index';
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';
import transporter from './tr-panelvan.png'

const TopContainerPrice = styled.div`
    width: 100vw;
    
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;

const TopContainer = styled.div`
    width: 100vw;
`;

const LineContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;

    padding-right: ${props => props.position === 'left' ? '8px' : 0};
    padding-left: ${props => props.position === 'right' ? '8px' : 0};
`;


const Line = styled.div`
    width: 100%;
    height: 2px;
    margin: 0;
`;

class BroschureText extends React.Component {

    constructor() {
        super();
        this.state = {
        }

        this.staticContainerPaddingVertical = { 
            top: ContainerPadding.grid001, 
        }

        this.staticContainerPaddingHorizontal = {
            left: ContainerPadding.grid002,
            right: ContainerPadding.grid002,
            ...this.staticContainerPaddingVertical
        }


        const centerAlignnment = TextAlignment.center;

        this.textAlign = {
            [Breakpoints.b2560]: centerAlignnment,
            [Breakpoints.b1920]: centerAlignnment,
            [Breakpoints.b1600]: centerAlignnment,
            [Breakpoints.b1280]: centerAlignnment,
            [Breakpoints.b960]: centerAlignnment,
        }

        const grid004Padding = ContainerPadding.grid004;
        const grid002Padding = ContainerPadding.grid002;

        const imagePadding = {
            [Breakpoints.b2560]: grid004Padding,
            [Breakpoints.b1920]: grid004Padding,
            [Breakpoints.b1600]: grid004Padding,
            [Breakpoints.b1280]: grid004Padding,
            [Breakpoints.b960]: grid002Padding,
        }

        this.image4DimensionsPadding = {
            left: imagePadding,
            right: imagePadding,
            top: ContainerPadding.dynamic0100
        }
    }


    renderTitle() {
        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;
        if (isMobile) {
            return (
                <Container
                    padding={padding4Dimensions}
                    horizontalAlign={ContainerHorizontalAlignment.center}
                >
                    <h2><Text  textAlign={TextAlignment.center} appearance={TextAppearance.headline0400}>
                    <b>Yeni aracınızla</b>&nbsp;<br />
                        <Text  appearance={TextAppearance.headline0400} >
                            ilgili bilgiler edinin
                        </Text>
                    </Text></h2>
                </Container>
            )
        } else {
            return (
                <Container
                    padding={padding4Dimensions}
                    horizontalAlign={ContainerHorizontalAlignment.center}
                >
                    <h2><Text  textAlign={TextAlignment.center} appearance={TextAppearance.headline0400}>
                        <b>Yeni aracınızla</b>&nbsp;
                    <Text appearance={TextAppearance.headline0400} >
                    ilgili bilgiler edinin
                    </Text>
                    </Text></h2>
                </Container>
            )
        }

    }


    renderInnerContainer() {

        const mainContainerPadding = {
            top: ContainerPadding.dynamic0300,
            bottom: ContainerPadding.dynamic0300
        }

        return (
            <Container
                padding={mainContainerPadding}
                horizontalAlign={ContainerHorizontalAlignment.center}
            >
                <Container
                    horizontalAlign={ContainerHorizontalAlignment.center}
                    stretchContent={true}
                    wrap={ContainerWrap.always}
                >
                    {this.renderTitle()}
                    {this.renderContainer()}
                </Container>
            </Container>
        )
    }

   
    renderUserInfo(){
        return(
            <Container wrap={ContainerWrap.always} padding={this.staticContainerPaddingVertical} >
                <h2><Text textAlign={this.textAlign} appearance={TextAppearance.headline0200} color={TextColor.secondary}>
                    İlgilendiğiniz modeli seçin
                </Text></h2>
                                            
            </Container>
        )
    }

    renderImage(){
        return (
            <Container padding={this.image4DimensionsPadding}>
                <Image src={transporter} alt={'volkswagen-ticari'} />
            </Container>
        )
    }


    renderDescriptionCar() {

        return ( 
            <Container wrap={ContainerWrap.always} padding={this.staticContainerPaddingVertical} gutter={ContainerGutter.static150}
            >
                <Text textAlign={this.textAlign} appearance={TextAppearance.copy0150} color={TextColor.secondary}>
                    Transporter Camlı Van
                </Text>
                <Link><Text textAlign={this.textAlign}  appearance={TextAppearance.label0250} bold>
                Başka model seçmek için tıklayın<br/>
                </Text></Link>
                <Text textAlign={this.textAlign}  appearance={TextAppearance.label0300} bold>
                3.0 V6 TDI 204 PS Otomatik<br/>
                </Text>
                <Button appearance={ButtonAppearance.Primary}>
                    Broşürü İndir
                </Button>
                                            
            </Container>
        )
    }

    renderContainer(){
        return(
            <Container 
                    padding={{ 
                        top: ContainerPadding.dynamic0250, 
                        bottom: ContainerPadding.dynamic0250 
                    }}
                    horizontalAlign={ContainerHorizontalAlignment.center}
                >
                    <Container 
                        wrap={ContainerWrap.always}
                        padding={this.staticContainerPaddingHorizontal}
                        horizontalAlign={ContainerHorizontalAlignment.center}
                    >
                        {this.renderUserInfo()}
                        {this.renderImage()}
                        {this.renderDescriptionCar()}
                    </Container>
                </Container>
        )
    }

render() {
    return(
        <LayoutTwo theme={'main'}>
        <div style={{ marginTop: '50px' }}>

            <Container horizontalAlign={ContainerHorizontalAlignment.center} padding={ContainerPadding.static200}>
                <ThemeProvider theme={'main'}>
                    <Container wrap={ContainerWrap.never} stretchContent={true}>
                        <TopContainerPrice>
                            {this.renderInnerContainer()}
                            
                        </TopContainerPrice>
                    </Container>
                </ThemeProvider>
            </Container>
        </div>
    </LayoutTwo>
    )
}


}

const globalPadding = {
    [Breakpoints.b1920]: ContainerPadding.grid007,
    [Breakpoints.b1600]: ContainerPadding.grid006,
    [Breakpoints.b1280]: ContainerPadding.grid005,
    [Breakpoints.b960]: ContainerPadding.grid004,
    [Breakpoints.default]: ContainerPadding.grid002 
}

const padding4Dimensions = {
    left: globalPadding,
    right: globalPadding,
    bottom: ContainerPadding.dynamic0100
}

const buttonLaneLayoutAppearance = {
    [Breakpoints.default]: [
        { name: '.', columns: 2 },
        { name: 'a', columns: 4 },
        { name: 'b', columns: 12 },
        { name: 'c', columns: 4 },
        { name: '.', columns: 2 }
    ],
    [Breakpoints.b560]: [
        { name: '.', columns: 2 },
        { name: 'a', columns: 6 },
        { name: 'b', columns: 8 },
        { name: 'c', columns: 6 },
        { name: '.', columns: 2 }
    ],
    [Breakpoints.b960]: [
        { name: '.', columns: 2 },
        { name: 'a', columns: 7 },
        { name: 'b', columns: 6 },
        { name: 'c', columns: 7 },
        { name: '.', columns: 2 }
    ],
    [Breakpoints.b1280]: [
        { name: '.', columns: 2 },
        { name: 'a', columns: 8 },
        { name: 'b', columns: 4 },
        { name: 'c', columns: 8 },
        { name: '.', columns: 2 }
    ]
}

export default BroschureText;